<template>
  <div v-if="items.length > 0">
    <section-title :has-line="true" title="Documentos" />
    <div v-for="(item, index) in items" :key="`training-document-${index}`">
      <div v-if="item.visible" class="p-3 ml-3 bg-secondary-3 rounded mb-3">
        <div class="row">
          <div class="col">
            <div class="color-secondary-6 font-14">Tipo de Documento:</div>
            <div class="font-weight-normal color-black font-16">
              {{ item.documentTypeName }}
            </div>
          </div>
          <div class="col d-flex justify-content-center align-items-center">
            <span
              v-if="item.isRequired"
              class="color-secondary-6 font-16 font-weight-normal"
            >
              Requerido
            </span>
          </div>
          <div class="col">
            <validation-provider
              v-slot="{ errors }"
              class="w-100"
              :name="'Documento' + index"
              :rules="required(item)"
            >
              <custom-file-input
                v-model="item.file"
                :accept="'.pdf'"
                :attachment-id="item.documentId"
                custom-error-msg="Favor anejar un documento."
                :disabled="isReadOnly"
                display-style="normal"
                :error="errors[0]"
                :name="item.documentId ? item.documentName : ''"
                @after-remove="
                  () => {
                    item.documentId = null;
                  }
                "
              />
            </validation-provider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomFileInput from '@/components/common/CustomFileInput';
import SectionTitle from '@/components/common/page/SectionTitle';

export default {
  name: 'TrainingDocument',
  components: {
    CustomFileInput,
    SectionTitle,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    required(item) {
      if (item.isRequired) {
        if (!item.File && !item.documentId) {
          return 'required';
        }
      }
      return '';
    },
  },
};
</script>
